<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :title="dialogTitle"
    width="50%"
    :before-close="handleClose"
  >
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="120px"
    >
      <el-form-item label="关联课程" prop="courseId">
        <el-select
          v-model="formData.courseId"
          placeholder="请选择关联课程"
          clearable
          filterable
          style="width: 400px"
          :disabled="formType == 'view'"
        >
          <el-option
            v-for="item in courseList"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="题型" prop="type">
        <el-radio-group
          v-model="formData.type"
          :disabled="formType == 'view'"
          @change="handleTypeChange"
        >
          <el-radio
            v-for="item in OQuestionType"
            :label="item.value"
            :key="item.value"
            >{{ item.label }}</el-radio
          >
        </el-radio-group>
      </el-form-item>

      <el-form-item label="题目" prop="title">
        <el-input
          v-model="formData.title"
          placeholder="填写题干"
          style="width: 400px"
          type="textarea"
          maxlength="300"
          rows="4"
          :disabled="formType == 'view'"
        ></el-input>
      </el-form-item>

      <div
        class="flex list_box"
        v-for="(item, index) in formData.titleOptionJson"
        :key="index"
      >
        <div class="flex align-items">
          <span class="video_span"
            ><span style="color: #f56c6c" v-if="index == 0">* </span>
            <span class="marginLeft10" v-if="index == 0">选项</span>
          </span>
          <div class="marginRight10">{{ item.num }}</div>
          <el-input
            v-model="item.name"
            placeholder="请输入"
            style="width: 400px"
            maxlength="30"
            :disabled="formType == 'view'"
          ></el-input>
          <i
            class="el-icon-delete marginLeft10 del_icon"
            @click="removeOption(index)"
            v-if="formData.type !== EQuestionType.judge && formData.titleOptionJson.length > 2"
          ></i>
        </div>
      </div>
      <el-button
        size="medium"
        type="primary"
        @click="addOption"
        icon="el-icon-plus"
        class="addBtn"
        v-if="formData.type !== EQuestionType.judge && formData.titleOptionJson.length < 10"
        >增加选项</el-button
      >
      <div class="daAn_box">
        <div class="label_span">
          <div style="color: #f56c6c">*</div>
          <div class="marginLeft10">答案</div>
        </div>

        <div class="daAn_list">
          <div
            class="daAn_item"
            v-for="(item, index) in formData.titleOptionJson"
            :key="index"
            :class="{ daAn_item_active: formData.answer.includes(item.num) }"
            @click="handleAnswer(index)"
          >
            {{ item.num }}
          </div>
        </div>
      </div>
    </el-form>
    <template #footer>
      <div class="flex" style="justify-content: center">
        <el-button
          :disabled="formLoading"
          type="primary"
          @click="submitForm"
          v-if="formType != 'view'"
          >保 存</el-button
        >
        <el-button @click="dialogVisible = false">
          {{ formType == "view" ? "关 闭" : "取 消" }}</el-button
        >
      </div>
    </template>
  </el-dialog>
</template>
<script>
import { Message } from "element-ui";
import { questionManageAdd, questionManageUpdate } from "@/api/question/manage";
import { courseInfoListAll } from "@/api/course/info";
import FormImgUpload from "@/components/formComponents/formImgUpload";
import { mobilePhoneRule } from "@/utils/formRules";
import dayjs from "dayjs";
import FormEditor from "@/components/formComponents/formEditor";
import FormVideoUpload from "@/components/formComponents/formVideoUpload";
import { EQuestionType, OQuestionType } from "@/enums/beCurrent/EBeCurrent";
export default {
  name: "index",
  components: {
    FormImgUpload,
    FormEditor,
    FormVideoUpload,
  },
  props: {},
  data() {
    return {
      EQuestionType,
      OQuestionType,
      dialogVisible: false, // 弹窗的是否展示
      dialogTitle: "", // 弹窗的标题
      formLoading: false, // 表单的加载中：1）修改时的数据加载；2）提交的按钮禁用
      formType: "", // 表单的类型：create - 新增；update - 修改
      courseList: [], // 全量课程下拉数据
      formData: {
        type: 1,
        title: "",
        courseId: "", // 关联课程ID
        answer: [], //答案
        titleOptionJson: [
          { num: "A", name: "", isAnswer: false },
          { num: "B", name: "", isAnswer: false },
        ], //接口需要转成对象提交
      },
      formRules: {
        courseId: [
          { required: true, message: "请选择关联课程", trigger: "change" },
        ],
        title: [{ required: true, message: "请输入", trigger: "blur" }],
        abbr: [{ required: true, message: "请输入", trigger: "blur" }],
      },
    };
  },
  created() {},
  methods: {
    /**
     * 获取全量课程列表下拉数据
     * 
     * @param {void} 无参数
     * @returns {Promise<void>} 无返回值
     */
    async getCourseList() {
      try {
        const res = await courseInfoListAll();
        if (res.code === 200 && Array.isArray(res.data)) {
          this.courseList = res.data;
        }
      } catch (error) {
        console.error("获取课程下拉列表失败:", error);
      }
    },

    /**
     * 打开弹窗并进行表单初始化/回显
     * 
     * @param {string} type 弹窗类型（create-新增，edit-修改，view-详情）
     * @param {Object} [item] 选中的数据项，包含题目各属性与关联课程ID等
     * @returns {Promise<void>} 无返回值
     */
    async open(type, item) {
      console.log(item, "zhe;li");
      this.dialogVisible = true;
      this.dialogTitle =
        type === "view" ? "详情" : type === "create" ? "新增" : "修改";
      this.formType = type;
      this.resetForm();
      await this.getCourseList();
      // 修改时，设置数据
      if (item && item.id) {
        this.formLoading = true;
        try {
          const newData = { ...item };

          this.formData = {
            ...newData,
            courseId: newData.courseId || "",
            titleOptionJson: Object.entries(newData.titleOptionJson).map(
              ([num, name]) => ({
                num,
                name,
              })
            ),
            answer: newData.answer.split(""),
          };
        } finally {
          this.formLoading = false;
        }
      }
    },

    /**
     * 提交题目表单
     * 校验数据完整性后将表单数据转为接口要求格式并发送增加/编辑请求
     * 
     * @param {void} 无参数
     * @returns {Promise<void>} 无返回值
     */
    async submitForm() {
      // 校验表单

      if (!this.$refs.formRef) return;
      // console.log(this.$refs.formRef.$refs.value, "zhe;li");
      const valid = await this.$refs.formRef.validate();

      if (!valid) return;
      // 判断选项值不能为空
      const emptyOptions = this.formData.titleOptionJson.filter(
        (item) => !item.name.trim()
      );
      if (emptyOptions.length > 0) {
        this.$message.error("选项内容不能为空");
        return;
      }
      // 判断答案不能为空
      if (this.formData.answer.length === 0) {
        this.$message.error("请选择答案");
        return;
      }
      // 如果是多选题(type=2)，判断答案至少选择两个
      if (
        this.formData.type == EQuestionType.multiple &&
        this.formData.answer.length < 2
      ) {
        this.$message.error("多选题答案至少需要选择两个选项");
        return;
      }

      try {
        this.formLoading = true;
        // 将选项数组转换为对象格式
        console.log(this.formData, "zhe;li");

        const optionsObject = {};
        this.formData.titleOptionJson.forEach((item) => {
          optionsObject[item.num] = item.name;
        });

        const newData = {
          ...this.formData,
          titleOptionJson: optionsObject,
          answer: this.formData.answer.join(""),
        };
        console.log(newData, "22222222222222");
        if (this.formType === "create") {
          const res = await questionManageAdd(newData);
          if (res.code == 200) {
            Message.success("新增成功");
          }
        } else {
          const res = await questionManageUpdate(newData);
          if (res.code == 200) {
            Message.success("修改成功");
          }
        }
        this.dialogVisible = false;
        // 发送操作成功的事件
        this.$emit("success");
        // setTimeout(() => {
        this.formLoading = false;
        // }, 1000);
      } catch (e) {
        // this.$message.error(e);
        this.formLoading = false;
      } finally {
      }
    },

    /**
     * 重置题目表单数据
     * 
     * @param {void} 无参数
     * @returns {void} 无返回值
     */
    resetForm() {
      this.formData = {
        type: 1,
        title: "",
        courseId: "",
        answer: [],
        titleOptionJson: [
          { num: "A", name: "" },
          { num: "B", name: "" },
        ],
      };
    },
    handleClose() {
      this.dialogVisible = false;
    },
    /**
     * 增加题目选项
     * 判断题不支持新增选项，单选/多选上限10个选项
     * 
     * @param {void} 无参数
     * @returns {void} 无返回值
     */
    addOption() {
      if (
        this.formData.type !== EQuestionType.judge &&
        this.formData.titleOptionJson.length < 10
      ) {
        this.formData.titleOptionJson.push({
          num: String.fromCharCode(65 + this.formData.titleOptionJson.length),
          name: "",
        });
      }
    },

    /**
     * 删除题目选项
     * 重新计算保留选项的字母编号
     * 
     * @param {number} index 要删除的选项索引
     * @returns {void} 无返回值
     */
    removeOption(index) {
      if (
        this.formData.type !== EQuestionType.judge &&
        this.formData.titleOptionJson.length > 2
      ) {
        this.formData.titleOptionJson.splice(index, 1);
        // 重新排序选项名称
        this.formData.titleOptionJson.forEach((item, idx) => {
          item.num = String.fromCharCode(65 + idx);
        });
      }
    },

    /**
     * 点击选定/取消选项答案
     * 单选题与判断题均为单选模式，多选题为多选模式
     * 
     * @param {number} index 点击的选项索引
     * @returns {void} 无返回值
     */
    handleAnswer(index) {
      if (
        this.formData.type === EQuestionType.single ||
        this.formData.type === EQuestionType.judge
      ) {
        this.formData.answer = [this.formData.titleOptionJson[index].num];
        console.log(this.formData.answer, "zhe;li");
      } else if (this.formData.type === EQuestionType.multiple) {
        const num = this.formData.titleOptionJson[index].num;
        const answerIndex = this.formData.answer.indexOf(num);
        if (answerIndex > -1) {
          this.formData.answer.splice(answerIndex, 1);
        } else {
          this.formData.answer.push(num);
        }
      }
    },

    /**
     * 切换题型事件回调
     * 清空已选答案；如切为判断题，自动预置“正确/错误”标准选项
     * 
     * @param {number} e 选中的题型 (1-单选题，2-多选题，3-判断题)
     * @returns {void} 无返回值
     */
    handleTypeChange(e) {
      this.formData.answer = [];
      if (e === EQuestionType.judge) {
        this.formData.titleOptionJson = [
          { num: "A", name: "正确" },
          { num: "B", name: "错误" },
        ];
      } else if (
        this.formData.titleOptionJson.length === 2 &&
        this.formData.titleOptionJson[0].name === "正确" &&
        this.formData.titleOptionJson[1].name === "错误"
      ) {
        this.formData.titleOptionJson = [
          { num: "A", name: "" },
          { num: "B", name: "" },
        ];
      }
    },
  },
};
</script>
<style scoped lang="scss">
.list_box {
  margin-left: 3%;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.video_icon {
  cursor: pointer;
  margin-top: 0.5%;
  margin-left: 10px;
}
.video_span {
  width: 80px;
  margin-left: 10px;
  display: inline-block;
}
/deep/.el-input__inner {
  text-align: left;
}

.addBtn {
  margin-left: 15%;
}

.daAn_box {
  margin-left: 3%;
  display: flex;
  align-items: center;
  .label_span {
    width: 80px;
    margin-left: 10px;
    display: flex;
    text-align: right;
    display: flex;
  }
  .daAn_list {
    display: flex;
    align-items: center;
    margin-top: 10px;

    .daAn_item {
      border: 1px solid #ddd;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      text-align: center;
      line-height: 40px;
      margin-right: 10px;
      cursor: pointer;
    }
    .daAn_item_active {
      background-color: #409eff;
      color: #fff;
    }
  }
}
.del_icon {
  font-size: 20px;
  cursor: pointer;
}
</style>
